var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFloppyDisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.25,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0zM11 17.25h5.625",
    stroke: "#00C8A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 1v2.5c0 .69.56 1.25 1.25 1.25h6.25c.69 0 1.25-.56 1.25-1.25V1",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 19.75H2.25c-.69 0-1.25-.56-1.25-1.25V6.41a2.5 2.5 0 0 1 .732-1.767l2.91-2.91A2.5 2.5 0 0 1 6.412 1H18.5c.69 0 1.25.56 1.25 1.25V18.5c0 .69-.56 1.25-1.25 1.25z",
    stroke: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFloppyDisk);
export default __webpack_public_path__ + "static/media/iconFloppyDisk.7e76920b4a700a21b4ed9ce27601aa3a.svg";
export { ForwardRef as ReactComponent };